import React from "react"
import { Form, FormGroup } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"
import Select, { createFilter } from "react-select"
import {getCountryCodeByTenant} from "../../../core/utils";
import {FINANCERS} from "../../../constants";

function SelectField({
  label,
  name,
  disabled,
  placeholder,
  options,
  enableMatchLabel,
  oneElement,
  clearIfNotExists = true,
  input,
  tenant,
  financerType,
  ...props
}) {
  return (
    <FinalFormField name={name} type="text" placeholder={placeholder} className="form-control">
      {({ input, meta }) => {
        const metaError = (meta.error || meta.submitError) && meta.touched

        // The value is either stored into value.value (maually case) or directly in value (what the back end sends)
        const value = input.value?.value || input.value

        // The value should match either the value of the option or its label (backend send birthCity as a Text that's why we match the label too)
        const optionById = options?.filter(
          (key) =>
            (key.value === value && value !== "") ||
            (enableMatchLabel && key?.label?.toUpperCase().match(value.toUpperCase()) && value !== "") ||
            (oneElement && options?.length === 1)
        )

        // To make sure that the selected option body in the code is the same as the selected one on the interface
        if (
          !!optionById &&
          optionById.length !== 0 &&
          (optionById[0]?.value !== value?.value || optionById[0]?.label !== value?.label)
        ) {
          input.onChange(optionById[0])
        }

        if (!input.value && options?.length > 0 && name === "identity.birthCountry" && FINANCERS.EVOLLIS === financerType) {
          input.onChange(options.find(option => option.value === getCountryCodeByTenant(tenant)))
        }

        // clear if value not in values
        if (value && !!optionById && optionById.length === 0 && clearIfNotExists) {
          input.onChange(null)
        }

        // Filter only on label configuration
        const filterConfig = {
          ignoreCase: true,
          ignoreAccents: true,
          matchFrom: "any",
          stringify: (option) => `${option.label}`,
          trim: true
        }

        return (
          <FormGroup>
            <div className="d-flex">
              {label && <Form.Label className="form-label">{label}</Form.Label>}
            </div>
            <Select
              {...input}
              classNamePrefix="react-select"
              className={metaError && "selectfield-error"}
              value={input.value}
              isDisabled={((disabled || oneElement) && options?.length === 1) || disabled}
              placeholder="Select..."
              options={options}
              isClearable
              inputId={`select-${name}`}
              onChange={(option) => {
                input.onChange(option)
              }}
              filterOption={createFilter(filterConfig)}
              captureMenuScroll={false}
              {...props}
            />
            {metaError && !(oneElement && options.length === 1) && (
              <p className="required-message">{meta.error || meta.submitError}</p>
            )}
          </FormGroup>
        )
      }}
    </FinalFormField>
  )
}

export default SelectField
